import * as store from '@attain-apps/fe/web/main/lib/store'
import { capitalize, getWords } from '@attain-apps/string-utils'

import type { Feature } from './feature'

export class Selectors {
  public readonly assistantName

  public readonly suggestedQuestions
  public readonly suggestedQuestionsLoading
  public readonly suggestedQuestionsError
  public readonly suggestedQuestionsErrorMessage

  public readonly messages

  public readonly askIsSubmitting
  public readonly askError
  public readonly askErrorMessage

  constructor(feature: Feature) {
    this.assistantName = feature.createSelector(() =>
      store.selectors.Selector.always(
        getWords(feature.name)
          .map(word => capitalize(word))
          .join(' '),
      ),
    )
    this.messages = feature.state.project(state => state.messages)

    this.suggestedQuestions = feature.state.project(
      state => state.suggestedQuestions,
    )
    const suggestedQuestionsRequest = feature.state.project(
      state => state.suggestedQuestionsRequest,
    )
    this.suggestedQuestionsLoading = suggestedQuestionsRequest.project(
      ({ isLoading }) => isLoading,
    )
    this.suggestedQuestionsError = suggestedQuestionsRequest.project(
      ({ error }) => error,
    )
    this.suggestedQuestionsErrorMessage = this.suggestedQuestionsError.project(
      error => error?.message,
    )

    const ask = feature.state.project(state => state.ask)
    this.askIsSubmitting = ask.project(({ isSubmitting }) => isSubmitting)
    this.askError = ask.project(({ error }) => error)
    this.askErrorMessage = this.askError.project(error => error?.message)
  }
}
